import { Observable } from 'rxjs';
import AxiosSubscriber from '../../factory/AxiosSubscriber';
// import sample from '../../json/sample/orderdetail.json';

export class OrderDetailAPI {
  constructor() {
    this.subscription = null;
  }

  subscribe(orderId, next, complete, error) {
    const token = localStorage.getItem("token");

    const httpConfig = {
      url: `/order/${orderId}`,
      method: 'get',
      headers: {
        'accept': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    };

    let observable$ = new Observable((observer) => {
      return new AxiosSubscriber(observer, httpConfig);
    });

    // let observable$ = new Observable.create((observer) => {
    //   observer.next(sample);
    //   observer.complete();
    // });

    this.subscription = observable$.subscribe({
      next: next,
      complete: complete,
      error: error
    });
  }

  unsubscribe() {
    if (this.subscription !== undefined && this.subscription !== null) {
      this.subscription.unsubscribe();
    }
  }
}